import { isLocationInUnitedStates } from '../../location/useCases/isLocationInUnitedStates'
import { isGlobal } from '../../term'
import { PageType, Term } from '../../../types/models'
import { Location } from '@/types/models/Location.model'
import { getAllLocationTitles } from '@/domain/location'
import { isNonEmptyArray } from '@/utils/checks'
import { isLocationPageType } from '@/domain/useCases/pageTypeCheck'

interface ShouldShowInternationalVideoCards {
  (props: { document: Term | Location; pageType: PageType }): boolean
}

export const shouldShowInternationalVideoCards: ShouldShowInternationalVideoCards =
  ({ document, pageType }) => {
    if (isLocationPageType(pageType)) {
      const allLocationTitles = getAllLocationTitles(document as Location)
      if (isNonEmptyArray(allLocationTitles)) {
        return !isLocationInUnitedStates(document as Location)
      }
    }

    return isGlobal(document)
  }
